(function () {
  'use strict';

  var STORAGE_KEY   = 'csr_data';

  /* ─── helpers ─────────────────────────────────────────────── */

  function isCollectionPage() {
    return !!document.querySelector('product-list');
  }

  function save(data) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function load() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  function clear() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ─── save on product-link click ──────────────────────────── */

  function attachSaveListener() {
    document.addEventListener('click', function (e) {
      if (!isCollectionPage()) return;
      var link = e.target.closest('a[href*="/products/"]');
      if (!link) return;

      // Collect all next-page URLs currently loaded by infinite scroll
      var pageUrls = [];
      document.querySelectorAll('.infinite-scroll-sentinel').forEach(function (s) {
        if (s.dataset.nextUrl) pageUrls.push(s.dataset.nextUrl);
      });

      save({
        url:      window.location.href,
        scrollY:  window.scrollY,
        pageUrls: pageUrls
      });
    }, true);
  }

  /* ─── restore on collection page load ─────────────────────── */

  async function restore(data) {
    if (!data || data.url !== window.location.href) { clear(); return; }
    if (!data.scrollY || data.scrollY <= 0)         { clear(); return; }

    var list     = document.querySelector('product-list');
    var sentinel = document.querySelector('.infinite-scroll-sentinel');
    if (!list)   { clear(); return; }

    /* 1. Temporarily disable the IntersectionObserver in infinite-scroll.js
          by hiding the sentinel off-screen until WE are done restoring.      */
    if (sentinel) {
      sentinel.style.visibility = 'hidden';
      sentinel.style.pointerEvents = 'none';
    }

    /* 2. Pre-load every page that was visible when the user left ----------- */
    var pagesToLoad = (data.pageUrls || []).slice();   // may be empty

    for (var i = 0; i < pagesToLoad.length; i++) {
      try {
        var resp = await fetch(pagesToLoad[i]);
        if (!resp.ok) break;

        var html    = new DOMParser().parseFromString(await resp.text(), 'text/html');
        var newList = html.querySelector('product-list');

        if (newList && list) {
          Array.from(newList.children).forEach(function (item) {
            item.removeAttribute('reveal-on-scroll');
            item.querySelectorAll('[reveal-on-scroll]').forEach(function (el) {
              el.removeAttribute('reveal-on-scroll');
            });
            item.style.opacity = '1';
            item.style.transform = 'none';
            list.appendChild(item);
          });
        }

        /* Update sentinel's next URL to keep infinite scroll chain intact */
        var newSentinel = html.querySelector('.infinite-scroll-sentinel');
        if (sentinel && newSentinel && newSentinel.dataset.nextUrl) {
          sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
        } else if (sentinel && (!newSentinel || !newSentinel.dataset.nextUrl)) {
          /* No more pages — remove sentinel entirely */
            sentinel.remove();
            sentinel = null;
          }
      } catch (err) {
        console.warn('[scroll-restore] failed to pre-load page:', pagesToLoad[i], err);
        break;
      }
    }

    /* 3. Scroll to saved position --------------------------------------- */
    var target   = data.scrollY;
    var attempts = 0;

    function tryScroll() {
      window.scrollTo({ top: target, behavior: 'instant' });
      attempts++;

      var reached = Math.abs(window.scrollY - target) < 50;
      if (!reached && attempts < 15) {
        setTimeout(tryScroll, 80);
        return;
      }

      /* 4. Re-enable the sentinel so normal infinite scroll resumes ----- */
      if (sentinel) {
        sentinel.style.visibility  = '';
          sentinel.style.pointerEvents = '';
        }

        clear();
    }

    /* Small paint delay so images/layout settle first */
    setTimeout(tryScroll, 200);
  }

  /* ─── boot ────────────────────────────────────────────────── */

  function init() {
    if (!isCollectionPage()) return;
    var data = load();
    if (data && data.url === window.location.href) {
      restore(data);
    } else {
      clear();
    }
    attachSaveListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();